import React, { useState, useEffect } from 'react'
import { FormikProps } from 'formik'
import { notification } from 'antd'
import { SelectValue } from 'antd/lib/select'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { AgreementServiceHub } from 'src/types'
import { AgreementsForm } from 'src/views/agencies/agreements/initial-values'
import { ApplicationState } from 'src/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'
import { getServiceHubs } from 'src/services/api/service-hub'
import { Select } from 'src/components/Formik'

interface Props {
  formikProps: FormikProps<AgreementsForm>
}

export default function SelectServiceHub({ formikProps }: Props) {
  const { me } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))

  const [loading, setLoading] = useState(false)
  const [list, setList] = useState<AgreementServiceHub[]>([])

  const { t } = useTranslation()

  useEffect(() => {
    if (me.user) {
      setLoading(true)
      getServiceHubs(me.user.organization_id)
        .then(function (response) {
          if (response.status === 200) {
            const service_hubs = response.data.service_hubs
            setList(service_hubs)
            if (service_hubs.length && !formikProps.values.service_hub_id) {
              const value = service_hubs[0].service_hub_id
              formikProps.setFieldValue('service_hub_id', `${value}`)
              formikProps.setFieldValue(
                'service_hub',
                list.find(item => +item.service_hub_id === +value)
              )
            }
            return
          }
          ClientNotifyCatch('Could not retrieve /service_hubs', response)
          notification.error({
            message: t('common.response.status-500'),
            placement: 'bottomRight'
          })
        })
        .catch(function (response) {
          ClientNotifyCatch('Could not retrieve /service_hubs', response)
          notification.error({
            message: t('common.response.status-500'),
            placement: 'bottomRight'
          })
        })
        .finally(function () {
          setLoading(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me.user])

  return (
    <Select
      dataTestId="service-hub-list"
      defaultActiveFirstOption={true}
      formikProps={formikProps}
      label="web.agreement.service-hub"
      loading={loading}
      name="service_hub_id"
      onChange={(value: SelectValue) => {
        formikProps.setFieldValue('service_hub_id', `${value}`)
        formikProps.setFieldValue(
          'service_hub',
          list.find(item => +item.service_hub_id === +value)
        )
      }}
      options={list.map(item => ({
        label: item.name,
        title: item.service_hub_type,
        value: `${item.service_hub_id}`
      }))}
    />
  )
}
